import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button, Divider } from "@material-ui/core";

import Home1 from "../../../Assets/Images/home1.png";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import NewArrival from "./NewArrival/NewArrival";
import WorkList from "./WorkList/WorkList";
import Subscribe from "./Subscribe/Subscribe";
import { connect } from "react-redux";
import { useStyles } from "./Home.css";

class Home extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header />
        <div
          id="homepart1"
          className={classes.root}
          style={{
            backgroundImage: `url(${Home1})`,
          }}
        >
          <div className={classes.homeTitleStyle}>
            <h1>Digi-Book</h1>
          </div>
          <div className={classes.bodyFoot}>
            <Button variant="outlined" className={classes.buttonStyle}>
              Learn more
            </Button>
          </div>
          <div className={classes.bodyText}>
            <p>
              Digi-Book provides a platform to publish your books and buy books
              digitally.
            </p>
          </div>
        </div>
        <br />
        <div style={{ paddingLeft: 10, paddingRight: 10 }}>
          <Divider style={{ height: 10, borderRadius: 10 }} />
        </div>
        <br />
        <WorkList />
        <br />

        <div style={{ paddingLeft: 10, paddingRight: 10 }}>
          <Divider style={{ height: 10, borderRadius: 10 }} />
        </div>

        {this.props.isAuthor === false &&
          (this.props.isAuth === true || this.props.isAuth === false) && (
            <NewArrival />
          )}

        <div style={{ padding: `10px 0 10px 0` }}>
          {this.props.isAuthor === false &&
            (this.props.isAuth === true || this.props.isAuth === false) && (
              <div id="homepart2">
                <Subscribe />
              </div>
            )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    isAuthor: state.AuthorReducer.isAuthor,
  };
};

export default connect(mapStateToProps, null)(withStyles(useStyles)(Home));
